import PropTypes from 'prop-types';

import {
  itinerarySideBarPropTypes,
  progressBarStepPropTypes,
  selectedOptionsPropTypes,
} from '../../../propTypes';
import { leadBookerPropTypes } from '../BookingFieldset/PropTypes';
import {
  currencyDepositAndTotalPricePropTypes,
  currencyDepositAndTotalPricePropTypesArrayPropTypes,
} from '../../../util/currency';

export const labelsPropTypes = PropTypes.shape({
  additionalCostText: PropTypes.string,
  addressFieldsetTitle: PropTypes.string,
  atolProtectedText: PropTypes.string,
  bankTransferNoConsentMessage: PropTypes.string,
  bankTransferNoConfirmMessage: PropTypes.string,
  bankTransferExpiredMessage: PropTypes.string,
  bankTransferFailedMessage: PropTypes.string,
  discountFieldsetTitle: PropTypes.string,
  discountLabelText: PropTypes.string,
  discountText: PropTypes.string,
  editPartyDetailsButtonText: PropTypes.string,
  editPartyDetailsMessage: PropTypes.string,
  editPartyDetailsTitle: PropTypes.string,
  extrasTitle: PropTypes.string,
  excursionsDateText: PropTypes.string,
  excursionsTimeText: PropTypes.string,
  failedToRetrieveCheckoutProcessSettingsMessage: PropTypes.string,
  flightArrivalDateTimeText: PropTypes.string,
  flightArrivalLocationText: PropTypes.string,
  flightClassText: PropTypes.string,
  flightDepartureDateTimeText: PropTypes.string,
  flightDepartureLocationText: PropTypes.string,
  flightNumberText: PropTypes.string,
  flightUpgradesHeader: PropTypes.string,
  hideDiscountInput: PropTypes.bool,
  hidePriorityAccessPassInput: PropTypes.bool,
  hotelRoomText: PropTypes.string,
  hotelUpgradesHeader: PropTypes.string,
  insuranceFieldsetTitle: PropTypes.string,
  insuranceNotRequiredOptionText: PropTypes.string,
  insuranceRequiredOptionText: PropTypes.string,
  invalidPaymentOptionMessage: PropTypes.string,
  invalidTourIdMessage: PropTypes.string,
  leadPartyMemberFieldsetTitle: PropTypes.string,
  linkedBookingHeadingText: PropTypes.string,
  linkedBookingLabelText: PropTypes.string,
  linkedBookingNameLabelText: PropTypes.string,
  linkedBookingReferenceLabelText: PropTypes.string,
  marketingSignUp1LabelText: PropTypes.string,
  marketingSignUp2LabelText: PropTypes.string,
  marketingSignUp3LabelText: PropTypes.string,
  marketingSignUp4LabelText: PropTypes.string,
  numberOfBerthText: PropTypes.string,
  packageInformationFieldsetTitle: PropTypes.string,
  partyDetailsFieldsetHeaderText: PropTypes.string,
  partyMemberFieldsetSubtitle: PropTypes.string,
  partyMemberFieldsetTitle: PropTypes.string,
  paymentFieldsetTitle: PropTypes.string,
  paymentOptionBankTransferText: PropTypes.string,
  paymentOptionBankTransferPayDepositText: PropTypes.string,
  paymentOptionBankTransferPayInFullText: PropTypes.string,
  paymentOptionCardText: PropTypes.string,
  paymentOptionCardPayDepositText: PropTypes.string,
  paymentOptionCardPayInFullText: PropTypes.string,
  placeholderTexts: PropTypes.object,
  preferredCardImage: null,
  priorityAccessPassLabelText: PropTypes.string,
  removeDiscountsSection: PropTypes.bool,
  roomAllocationFieldsetTitle: PropTypes.string,
  salesAgentSendCustomerEmailButtonText: PropTypes.string,
  salesAgentSendToUserHeadingText: PropTypes.string,
  selectedExcursionsHeader: PropTypes.string,
  sessionInvalidTourIdMessage: PropTypes.string,
  submitButtonText: PropTypes.string,
  termsConditionsHeaderText: PropTypes.string,
  termsConditionsLabelText: PropTypes.string,
  ticketCategoryText: PropTypes.string,
  ticketUpgradesHeader: PropTypes.string,
  titleOptions: PropTypes.arrayOf(PropTypes.string),
  totalToPayText: PropTypes.string,
  transportDepartureLocationText: PropTypes.string,
  transportArrivalDepartureLocationText: PropTypes.string,
  transportOutboundDepartureDateTimeTextText: PropTypes.string,
  transportOutboundArrivalDateTimeTextText: PropTypes.string,
  transportInboundDepartureDateTimeTextText: PropTypes.string,
  transportInboundArrivalDateTimeTextText: PropTypes.string,
  transportUpgradesHeader: PropTypes.string,
  upgradesHeader: PropTypes.string,
  validationReviewFields: PropTypes.string,
  validationEmailAddressInvalid: PropTypes.string,
  validationEmailAddressesDoNotMatch: PropTypes.string,
});

export const summaryLoadPropTypes = PropTypes.shape({
  allowsDeposit: PropTypes.bool,
  bankTransferPaymentsEnabled: PropTypes.bool,
  editPartyDetailsUrl: PropTypes.string,
  errorCode: PropTypes.number,
  errorMessage: PropTypes.string,
  insuranceText: PropTypes.string,
  isSalesAgentBooking: PropTypes.bool,
  isSalesAgentUserLoggedIn: PropTypes.bool,
  itinerarySideBar: itinerarySideBarPropTypes,
  leadBooker: leadBookerPropTypes,
  linkedBookingName: PropTypes.string,
  linkedBookingReference: PropTypes.string,
  marketingSignUp1: PropTypes.bool,
  marketingSignUp2: PropTypes.bool,
  marketingSignUp3: PropTypes.bool,
  marketingSignUp4: PropTypes.bool,
  pricePerCurrency: currencyDepositAndTotalPricePropTypesArrayPropTypes,
  progressBarSteps: PropTypes.arrayOf(progressBarStepPropTypes),
  selectedOptions: selectedOptionsPropTypes,
  termsAndConditionsText: PropTypes.string,
  tourDescription: PropTypes.string,
  tourFromDate: PropTypes.string,
  tourName: PropTypes.string,
  tournamentName: PropTypes.string,
  tourToDate: PropTypes.string,
});
